// Author thq
// Date 2024-06-05 11:03:39

class EmSppStorageInfoSti {
constructor({
        id = null,
        stiIdSpa = '',
        stiCodeSpa = '',
        stiNameSpa = '',
        stiCodeSat = '',
        stiCodeEloc = '',
        stiCode = '',
        stiQuantity = '',
        stiUnit = ''}
= {}) {
    this.id = id;
    this.stiIdSpa = stiIdSpa;
    this.stiCodeSpa = stiCodeSpa;
    this.stiNameSpa = stiNameSpa;
    this.stiCodeSat = stiCodeSat;
    this.stiCodeEloc = stiCodeEloc;
    this.stiCode = stiCode;
    this.stiQuantity = stiQuantity;
    this.stiUnit = stiUnit;
}
}

function newEntity() {
return new EmSppStorageInfoSti();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiCodeSpa',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiCodeSpa',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiNameSpa',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiNameSpa',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiType',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiNameSat',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiNameSat',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiCodeEloc',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiCodeEloc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiNameEloc',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiNameEloc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiQuantity',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiUnit',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiUnit',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'stiCode',
        label: 'label.em.spareparts.emSppStorageInfoSti.grid.stiCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    stiIdSpaFilter : '',
    nameBdaFilter : '',
    idBdaFilter : '',
    stiCodeSpaFilter : '',
    stiNameSpaFilter : '',
    stiSearchTypeFilter : '',
    stiCodeElocFilter : '',
    stiCodeSatFilter : '',
    stiCodeFilter : '',
    stiQuantityFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameBdaFilter',
        label: 'label.em.spareparts.emSppStorageInfoSti.filter.nameBda',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"idBda":"id"}'
                }
        },
        {
        key: 'stiCodeSpaFilter',
        label: 'label.em.spareparts.emSppStorageInfoSti.filter.stiCodeSpa',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stiNameSpaFilter',
        label: 'label.em.spareparts.emSppStorageInfoSti.filter.stiNameSpa',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stiSearchTypeFilter',
        label: 'label.em.spareparts.emSppStorageInfoSti.filter.stiSearchType',
        disabled: false,
        form: {
        type: 'select',
        modalMultiSelectedType: 'string'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '机旁库' },
                { value: '2', text: 'NC库存' },
                { value: '3', text: 'NC采购状态' }
            ]
        }
        },
        {
        key: 'stiCodeElocFilter',
        label: 'label.em.spareparts.emSppStorageInfoSti.filter.stiCodeEloc',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emSppLocation'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'stiCodeSatFilter',
        label: 'label.em.spareparts.emSppStorageInfoSti.filter.stiCodeSat',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emSppAttribute'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'stiCodeFilter',
        label: 'label.em.spareparts.emSppStorageInfoSti.filter.stiCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'stiIdSpa',
        label: 'label.em.spareparts.emSppStorageInfoSti.entity.stiIdSpa',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stiCodeSpa',
        label: 'label.em.spareparts.emSppStorageInfoSti.entity.stiCodeSpa',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stiNameSpa',
        label: 'label.em.spareparts.emSppStorageInfoSti.entity.stiNameSpa',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stiCodeSat',
        label: 'label.em.spareparts.emSppStorageInfoSti.entity.stiCodeSat',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stiCodeEloc',
        label: 'label.em.spareparts.emSppStorageInfoSti.entity.stiCodeEloc',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emSppStorageLoc'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'stiCode',
        label: 'label.em.spareparts.emSppStorageInfoSti.entity.stiCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stiQuantity',
        label: 'label.em.spareparts.emSppStorageInfoSti.entity.stiQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'stiUnit',
        label: 'label.em.spareparts.emSppStorageInfoSti.entity.stiUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmSppStorageInfoSti, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
